var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgMobileBack = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 25, height: 25, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M17.312 3.115a1.301 1.301 0 0 0-1.843 0l-8.657 8.656a1.037 1.037 0 0 0 0 1.469l8.657 8.656c.51.51 1.333.51 1.843 0s.51-1.333 0-1.844L9.771 12.5l7.552-7.552c.5-.5.5-1.333-.01-1.833Z", fill: "#fff", stroke: "#fff", strokeWidth: 0.4 }));
export { SvgMobileBack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3LjMxMiAzLjExNWExLjMwMSAxLjMwMSAwIDAgMC0xLjg0MyAwbC04LjY1NyA4LjY1NmExLjAzNyAxLjAzNyAwIDAgMCAwIDEuNDY5bDguNjU3IDguNjU2Yy41MS41MSAxLjMzMy41MSAxLjg0MyAwcy41MS0xLjMzMyAwLTEuODQ0TDkuNzcxIDEyLjVsNy41NTItNy41NTJjLjUtLjUuNS0xLjMzMy0uMDEtMS44MzNaIiBmaWxsPSIjZmZmIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iLjQiLz48L3N2Zz4=";
